export default function LoadingFallback() {
  return (
    <div className="loading-fallback" role="status" aria-label="Loading page">
      <span className="loading-fallback__text">Finding the signal...</span>
    </div>
  );
}
